import BaseView from "./_BaseView";
import Table from "../components/Table";
import Confirm from "../components/Confirm";
import Api from "../Api";

export default class BillingView extends BaseView
{
    init() {
        super.init();

        if ($('#invoiceTable').length > 0) {
            this.table = new Table('invoiceTable', `/api/invoices?org_id=${this.org}`, [
                {data: 'date', orderable: true},
                {data: 'amount'},
                {data: 'status'}
            ]);
        }

        if ($('#paymentTable').length > 0) {
            this.payment_table = new Table('paymentTable', `/api/payments?org_id=${this.org}`, [
                {data: 'name'},
                {data: 'exp'},
                {data: 'tools'}
            ]);
        }
    }

    setEvents() {
        const self = this;
        super.setEvents();

        $('.update-payment').on('click', function () {
            Api.getTpl('new-payment').done(r => {
                const tpl = _.template(r);

                Confirm({
                    title: 'New Payment Method',
                    ok: '',
                    cancel: Lang.cancel,
                    classes: 'large-modal',
                    msg: tpl(),
                    onClose: function () {
                        self.payment_table.reload();
                    }
                });
            });
            return false;
        });
    }
}
